import { Button } from "reactstrap"

interface ActionRowProps {
    className?: string
    onSearch?: () => void
    onReset?: () => void
    disableSearch?: boolean
}
export const ActionRow = ({ className, onSearch, onReset, disableSearch}: ActionRowProps) =>
    <div className={`d-flex justify-content-between flex-row-reverse ${className ?? ''}`}>
        <Button color='primary' onClick={onSearch} disabled={disableSearch}>Search</Button>
        <Button onClick={onReset}>Reset</Button>
    </div>
